/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import ReactPaginate from "react-paginate";

export interface IPaginateProps {
  totalItems: number;
  breakLabel?: string;
  nextLabel?: string;
  onPageChange?(event: any): void;
  pageRangeDisplayed?: number;
  totalPages: number;
  currentPage?: number;
  totalCount: number;
  previousLabel?: string;
  pageSizeOptions?: number[];
  pageSize?: number;
  onPageSizeChange?(pageSize: number): void;
  textColor?: string;
}

export const Paginate = ({
  totalItems,
  totalCount,
  breakLabel,
  nextLabel,
  currentPage,
  onPageChange,
  pageRangeDisplayed,
  totalPages,
  previousLabel,
  pageSizeOptions,
  pageSize,
  onPageSizeChange,
  textColor,
}: IPaginateProps) => {
  const [pages, setPages] = useState<number>(totalPages);
  const [count, setCount] = useState<number>(totalCount);

  useEffect(() => {
    if (totalCount !== undefined) {
      setCount(totalCount);
      setPages(Math.ceil(totalCount / (pageSize || 10)));
    } else if (totalPages > 0) {
      setPages(totalPages);
    }
  }, [totalCount, totalPages, pageSize]);



  return (
    <Card.Footer className="px-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
      <ReactPaginate
        breakLabel={breakLabel}
        nextLabel={nextLabel}
        onPageChange={onPageChange}
        pageRangeDisplayed={pageRangeDisplayed}
        pageCount={Math.ceil(pages) || 0}
        previousLabel={previousLabel}
        breakClassName={"page-item"}
        breakLinkClassName={"page-link"}
        containerClassName={"pagination"}
        pageClassName={"page-item"}
        pageLinkClassName={"page-link"}
        previousClassName={"page-item"}
        previousLinkClassName={"page-link"}
        nextClassName={"page-item"}
        nextLinkClassName={"page-link"}
        activeClassName={"active"}
        forcePage={(Math.ceil(pages) || 0) === 0 ? -1 : (currentPage ?? 1) - 1}
      />
      <div className="d-flex align-items-center mt-4 mt-lg-0">
        {onPageSizeChange && pageSizeOptions && (
          <div className="d-flex align-items-center me-3">
            <span className="me-2" style={{ fontSize: "0.875rem", color: textColor || "inherit" }}>
              Rows per page:
            </span>
            <select
              className="form-select form-select-sm"
              style={{
                display: "inline-block",
                cursor: "pointer",
                paddingRight: "2rem",
                width: "max-content"
              }}
              value={pageSize ?? 10}
              onChange={(e) => onPageSizeChange(Number(e.target.value))}
            >
              {pageSizeOptions.map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          </div>
        )}
        {totalItems && (
          <small
            className="fw-normal"
            style={{ justifyContent: "flex-end", color: textColor || "inherit" }}
          >
            Showing <b>{totalItems ?? 0}</b> out of <b>{count ?? 0}</b> entries
          </small>
        )}
      </div>
    </Card.Footer>
  );
};

Paginate.defaultProps = {
  breakLabel: "...",
  nextLabel: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
      className="icon icon-xs"
    >
      <path
        fill-rule="evenodd"
        d="M10.293 15.707a1 1 0 010-1.414L14.586 10l-4.293-4.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z"
        clip-rule="evenodd"
      ></path>
      <path
        fill-rule="evenodd"
        d="M4.293 15.707a1 1 0 010-1.414L8.586 10 4.293 5.707a1 1 0 011.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z"
        clip-rule="evenodd"
      ></path>
    </svg>
  ),
  pageRangeDisplayed: 5,
  previousLabel: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
      className="icon icon-xs"
    >
      <path
        fill-rule="evenodd"
        d="M15.707 15.707a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 010 1.414zm-6 0a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 011.414 1.414L5.414 10l4.293 4.293a1 1 0 010 1.414z"
        clip-rule="evenodd"
      ></path>
    </svg>
  ),
};
